import { render, staticRenderFns } from "./goodsAdd.vue?vue&type=template&id=3153a706&scoped=true&"
import script from "./goodsAdd.vue?vue&type=script&lang=js&"
export * from "./goodsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3153a706",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3153a706')) {
      api.createRecord('3153a706', component.options)
    } else {
      api.reload('3153a706', component.options)
    }
    module.hot.accept("./goodsAdd.vue?vue&type=template&id=3153a706&scoped=true&", function () {
      api.rerender('3153a706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/event/components/goodsAdd.vue"
export default component.exports